import { useContext, useEffect, useState } from "react";
import {
  getCatalogs,
} from "../services/console/catalogue";
import { AppContext } from "../context";
import { useNavigate } from "react-router-dom";

type UseType = "DATA" | "ACTIONS";
type ActionType = "CREATE" | "UPDATE" | "DELETE" | "REACTIVE";

const handleMasterCategoryActionFunction = (action: ActionType, t: Function) => {
  switch (action) {
    case "CREATE":
      return {
        actionFn: (a:any)=>{},
        fnMsg: t("Tenants.apiCreateLabel"),
        actionType: action
      };
    case "UPDATE":
      return {
        actionFn: (a:any)=>{},
        fnMsg: t("Tenants.apiUpdateLabel"),
        actionType: action
      };
    case "DELETE":
      return {
        actionFn: (a:any)=>{},
        fnMsg: t("Tenants.apiDeleteLabel"),
        actionType: action
      };
    case "REACTIVE":
      return {
        actionFn: (a:any)=>{},
        fnMsg: t("Tenants.apiReactiveLabel"),
        actionType: action
      };
    default:
      return {
        actionFn: () => {},
        fnMsg: "",
        actionType: ""
      };
  }
};

export const useMasterCategory = (type: UseType) => {
  const {
    t,
    toast,
    appState: { selectedApp },
    setAppState,
  } = useContext(AppContext);
  const [data, setData] = useState<any | null>(null);
  const [reload, setReload] = useState<number>(0);
  const appid = selectedApp?.appid || "0";
  const navigate = useNavigate();

  const reloadFn = () => {
    setData(null);
    setReload((prev) => prev + 1);
  };

  const masterCategoryAction = async (action: ActionType, data: any) => {
    const { actionFn, fnMsg, actionType } = handleMasterCategoryActionFunction(action, t);
    setAppState((prev) => ({
      ...prev,
      isLoading: true,
    }));
    // TOAST DATA VARIABLE
    let toastData:{} | null = null
    const actionStatus = await Promise.resolve(actionFn(data))
      .then((_) => {
        toastData = {
          severity: "success",
          summary: "",
          detail: `${fnMsg}`,
          life: 3000,
        }
        if (actionType !== 'UPDATE') {
          toast.current.replace(toastData);
        }
        return "SUCCESS";
      })
      .catch((error) => {
        toastData = {
          severity: "error",
          summary: "",
          detail: error?.response?.data?.header?.errorMsg ?? t('ConsoleTranslations.generalErrorApiMessage'),
          life: 3000,
        }
        if (actionType !== 'UPDATE') {
          toast.current.replace(toastData);
        }
        return "ERROR";
      });
    setAppState((prev) => ({
      ...prev,
      isLoading: false,
      toastData,
    }));
    if (actionType === 'UPDATE') {
      navigate('/tenants')
    }
    return actionStatus;
  };

  useEffect(() => {
    if (type === "DATA" && appid) {
      (async function () {
        await Promise.resolve(getCatalogs())
          .then((response) => {
            setData(response?.data);
          })
          .catch((error) => {
            toast.current.replace({
              severity: "error",
              summary: "",
              detail: error?.response?.header?.errorMsg ?? t('ConsoleTranslations.generalErrorApiMessage'),
              life: 3000,
            });
          });
      })();
    }
  }, [appid, toast, reload, type]);

  return {
    data,
    masterCategoryAction,
    reloadFn,
  };
};